/** @jsx jsx */

import { Icon } from '@zapier/zinnia-icons';

import { Tooltip, TooltipFocusableTrigger } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import StatusLabel from 'app/developer-v3/components/StatusLabel';
import {
  VersionLifecycle,
  VersionLifecycleStatus,
} from 'app/developer-v3/types/statuses';
import { toSentenceCase } from 'app/developer-v3/utils/text';

const Styles = {
  popoverWrapper: css`
    margin-left: 5px;
    cursor: pointer;
  `,
  statusWrapper: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
};

type Props = {
  usersExceedLimit: boolean;
  versionLifecycle: VersionLifecycle;
};

const Status = ({ usersExceedLimit, versionLifecycle }: Props) => {
  const isPromoted =
    versionLifecycle.status === VersionLifecycleStatus.promoted;

  return (
    <div css={Styles.statusWrapper}>
      <StatusLabel
        label={toSentenceCase(versionLifecycle.status)}
        variant={isPromoted ? 'success' : undefined}
      />
      {(isPromoted || usersExceedLimit) && (
        <div
          aria-label="Integration cannot be edited"
          css={Styles.popoverWrapper}
        >
          <Tooltip
            allowMultiline={true}
            content={
              usersExceedLimit
                ? `This version is ${versionLifecycle.status} and has more than 5 active users and therefore cannot be edited.`
                : 'This version is promoted and therefore cannot be edited.'
            }
            placement="bottom end"
          >
            <TooltipFocusableTrigger>
              <Icon aria-label="Locked" name="actionLockFill" size={24} />
            </TooltipFocusableTrigger>
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default Status;
